module.exports = __webpack_public_path__ + "img/connieChing.c0c9836c.png";